export default class User {
  constructor(_user) {
    Object.keys(_user).forEach((_key) => {
      this[_key] = _user[_key];
    });
  }

  getImage() {
    if (this.image && this.image.link) return this.image.link;
    return null;
  }
}
